import { useEffect, useMemo, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetCategoriesData, GetPackagesData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { packagesColumns, positionOfPackags, TopResultOfPackags } from "../../lib/definitions";
import { deletePackagesForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useLocation, useSearchParams } from "react-router-dom";
import PackagesFilter from "../../ui/searchFilter/packagesFilter";
import i18n from "../../lib/i18n";
import PackageCard from "../../ui/packagesUi/packageCard";

export default function Packages() {

    const [searchParams] = useSearchParams();
    // const [categoriesData, setCategoriesData] = useState([]);
    const deleteRef = useRef(null);
    const [packagesData, setPackagesData] = useState([]);
    const [categoriesDataFilter, setCategoriesDataFilter] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false); 
    const location = useLocation(); 
    // const user = JSON.parse(localStorage.getItem("userData"));
    // const userType = user.type;
    const sub_category_id = searchParams.get('sub_category_id');
    const name = searchParams.get('name');
    const price = searchParams.get('price');
    const position = searchParams.get('position');
    const topResult = searchParams.get('topResult');
    const t = i18n.t.bind(i18n); 

    const params = useMemo(() => {
        const tempParams = [];
        if (sub_category_id) tempParams.push({ sub_category_id });
        if (name) tempParams.push({ name });
        if (topResult) tempParams.push({ topResult });
        if (position) tempParams.push({ position });
        if (price) tempParams.push({ price });

        return tempParams;
    }, [ price, sub_category_id, name, position, topResult]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    useEffect(() => {
        handleFilter();
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);

    const handleApi = async () => {
        setIsLoading(true); 
        const packagesData = await GetPackagesData(currentPage, params);
        // const categoriesData = await GetCategoriesData(currentPage, params);
        // setCategoriesData([]);
        setPackagesData([]);
        setcurrentPage(packagesData.pagination.current_page);
        setlast_page(packagesData.pagination.last_page);
        packagesData.data.map((e) => setPackagesData((prev) => [...prev, e]));
        // categoriesData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const handleFilter = async () => {
            const params = [{"status":"sub"}];
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesDataFilter((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param},{"status":"sub"}];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesDataFilter((prev) => [...prev, e]));
        }
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deletePackagesForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            {!location.pathname.startsWith("/users/details/") &&
                (<>
                    <div className="">
                        <PackagesFilter search={search} categoriesData={categoriesDataFilter} values={params} positionOfPackags={positionOfPackags} TopResultOfPackags={TopResultOfPackags} />
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                        <h1 className="text-white text-lg ">{t("nav.packages")}</h1>
                        <Button background="#D36300" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_packages")} nav={"/packages/add"}  />
                    </div>
                </>)
            }
            <div>
                {isLoading ? <TableSkeleton cols={packagesColumns}/> : (  
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-center sm:mx-14 mx-2 gap-10 mt-6">
                    {packagesData.map((pkg) => (
                    <PackageCard
                        key={pkg.id}
                        pkg={pkg}
                        openDeleteConfirmation={openDeleteConfirmation}
                        editLink="/packages/edit"
                    />
                    ))}
                </div>
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};